export const isUserFreemium = (userData) =>
    userData && userData.benefit && userData.benefit === 'MOBILE';

export const hasRelevantPackage = (item, userData) =>
    // eslint-disable-next-line no-unneeded-ternary
    item.data?.pckg?.id && userData?.packages?.includes(item.data.pckg.id) ? true : false;
